// export const domain =  'https://ukrainiangirls.pw';
// export const domain =  'http://localhost';
//  export const domain =  'https://testplug.help-chat.com.ua';
export const domain =  'https://ukrainiangirls.pw';
// export const domain =  'http://localhost';

export const AUTH_ROUTES = {
    login: domain + '/api/login',
    register:  domain + '/api/register',
    logout:  domain + '/api/logout',
    balance:  domain + '/api/balance',
    getPayments: domain + '/api/v1/get-payments',
    changePassword:  domain + '/api/change-password',
    forgotPassword:  domain + '/api/forgot-password',
    getTariffs: domain + '/api/v1/get-tariffs'
}

export const CLIENTS_ROUTES = {
    getClients: domain + '/api/v1/get-clients',
    getNews: domain + '/api/v1/get-news',
    getSites: domain + '/api/v1/get-sites',
    addClients: domain + '/api/v1/add-clients',
    removeClients: domain + '/api/v1/remove-clients',
    lockClients: domain + '/api/v1/lock-clients',
    lockCaptcha: domain + '/api/v1/lock-captcha',
    editClient: domain + '/api/clients/edit-client',
    getUser: domain + '/api/v1/get-user',
    changePlan: domain + '/api/v1/change-plan',
    getPurchases: domain + '/api/v1/get-purchases',
    getClientPurchases: domain + '/api/v1/get-client-purchases',
    changeLabel: domain + '/api/v1/change-label',
    changeName: domain + '/api/v1/change-name',
    paymentData: domain + '/api/v1/get-payment-data',
}

export const STAT_ROUTES = {
    getCommonUserStat: domain + '/api/v1/get-common-user-stat',
    getCommonUserStatGroupedByDay: domain + '/api/v1/stat-group-day'
}

export const PAYMENT_ROUTES ={
    returnUrl: domain + '/payment-callback',
    callbackWayForPay: domain + '/process-notification-way-for-pay',
}
export const WHITELIST_ROUTES ={
    getWhitelists: domain + '/api/v1/get-whitelists',
    updateWhitelists: domain + '/api/v1/update-whitelist',
}